/* eslint-disable react/prop-types */
import { Bar, Pie, TextDisplay } from '../index.js'
import React from 'react'

export const MasteryPoints = ({ data }) => {
  return (
    <>
    {Object.keys(data).length > 0 &&
      <div className="alert">
        <strong>Notice:</strong> Data for champions released after Vex are missing due to current limitations.
      </div>
    }
      <div className="graphs-container">
        <div><Bar data={data?.dataByLevel} title="Champion Mastery Distribution"/></div>
        <div><Pie data={data?.dataByLevel} title="Champion Mastery Distribution" /></div>
        <div><Bar data={data?.allMasteryPointsData} title="Champion Mastery Points"/></div>
        <div><Bar data={data?.pre5MasteryPointsData} title="Champion Mastery Points until level 5"/></div>
      </div>
      {Object.keys(data).length > 0 &&
      <div style={{ width: '90%', height: 'auto', margin: 'auto' }}>
        <TextDisplay data={data?.textDisplayData} />
      </div>
      }
    </>
  )
}
